export var fromPropertyOption = function (o) {
    var _a, _b;
    return {
        id: o.id,
        displayName: o.displayName,
        colour: ((_a = o.display) === null || _a === void 0 ? void 0 : _a.kind) === 'swatch' ? o.display.value : undefined,
        image: ((_b = o.display) === null || _b === void 0 ? void 0 : _b.kind) === 'image' ? o.display.url : undefined,
        status: o.status,
        compatible: o.compatible,
    };
};
